module.exports = __webpack_public_path__ + "static/media/main_theme.666481fa.jpg";